// extracted by mini-css-extract-plugin
export default {"title":"blog-posts-module--title--TKDQQ","section":"blog-posts-module--section--sN7Gc","item":"blog-posts-module--item--GZt4G","navigation":"blog-posts-module--navigation--x0d8s"};